export default {"src":"/_next/static/media/icon-pinterest.3db93f97.svg","height":75,"width":75};